import React from "react";
import RevealOnView from "@/components/site/RevealOnView";

export default function PartnerTeaser() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <div aria-hidden className="absolute inset-0 pointer-events-none"
        style={{ background: "linear-gradient(to bottom, rgba(201,168,106,0.05) 0%, transparent 100%)" }} />
      <div className="max-w-[1240px] mx-auto px-5 md:px-8 relative">
        <RevealOnView delay={1} className="max-w-[760px]">
          <div className="text-[11px] tracking-[0.24em] uppercase text-neutral-500 mb-5">
            <span className="inline-block w-6 h-px align-middle mr-3" style={{ background: "#c9a86a" }} />
            Programma partner
          </div>
          <h2 className="font-display text-[32px] sm:text-[42px] md:text-[52px] leading-[1.05] tracking-[-0.02em] font-light text-neutral-950">
            Sei una location o un fornitore<br className="hidden md:block" /> di matrimoni?
          </h2>
          <p className="mt-5 text-[15px] md:text-[17px] text-neutral-600 max-w-lg leading-relaxed">
            Diventa partner WedFlow: guadagna su ogni matrimonio e offri ai tuoi clienti
            un'esperienza che ricorderanno.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <a href="/partner"
              className="wf-btn-primary rounded-full px-7 py-3.5 text-[13px] tracking-wide text-center">
              Scopri il programma →
            </a>
            <a href="/WedFlow-Brochure-Partner.pdf" download
              className="rounded-full px-7 py-3.5 text-[13px] tracking-wide text-center border border-neutral-200 text-neutral-600 hover:border-neutral-400 transition-all">
              ↓ Scarica la brochure
            </a>
          </div>
        </RevealOnView>
      </div>
    </section>
  );
}
